import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { RequestBoxSendService } from './services/requestBoxSend.service';
import { ProductRoadmapService } from '../productRoadmap/services/productRoadmap.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';

declare function baseTracking(appId);

declare function enterScreenView(screenName: any, contentType: any, referrer: any);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare var $: any;

@Component({
  selector: 'app-requestBoxSend',
  templateUrl: './requestBoxSend.component.html',
  styleUrls: ['./requestBoxSend.component.css'],
  providers: [RequestBoxSendService, ProductRoadmapService],
})
export class RequestBoxSendComponent implements OnInit {
  form = this.fb.group({});
  page_title: string;
  // isDistribution: Boolean = false;
  // isList: Boolean = true;
  stasitic: object = {
    total_product: 1000,
    total_show: 20000,
  };
  lotem: string;

  data = [];
  item_active: any;
  pageIndex = 1;
  page_size = 10;
  totalPage: number;
  item_detail: any = {
    id: 1,
    name: 'IC-000001',
  };
  statistic;
  supplier = [];
  query;
  loading_left = false;
  total_data: 0;
  stampSerialDetail;
  bundleType;
  public area: Array<any> = [];
  @ViewChild('returnStampBox') returnStampBox: ModalDirective;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    public requestBoxSendService: RequestBoxSendService,
    public productRoadmapService: ProductRoadmapService,
    public router: Router,
    private translate: TranslateService,
  ) {
  }

  ngOnInit() {
    baseTracking(environment.appIdTracking);
    enterScreenView('qcheck_reback_manage', 'others', '');
    this.page_title = this.translate.instant('YEU_CAU_TRA_HANG');
    this.getArea();
    this.initSelect2();
    this.translate.onLangChange.subscribe(() => {
      this.page_title = this.translate.instant('YEU_CAU_TRA_HANG');
      this.initSelect2();
    });
    this.statisticList();
    this.productRoadmapService.getSupplier(this.query).subscribe((res) => {
      const supplier = [];
      res.data.items.map((val) => {
        supplier.push({ label: val.name, value: val.id });
      });
      this.supplier = supplier;
    });
    this.fetch();
  }

  private initSelect2() {
    this.translate.get([
      'KHU_VUC',
      'TRANG_THAI',
      'LOAI_TEM',
      'CHON_NHA_CUNG_CAP',
    ]).subscribe(t => {
      ['#area', '#statusSearch', '#typeTemp', '#supplier'].forEach(id => {
        if ($(id).data('select2')) { $(id).select2('destroy'); }
      });
      $('#area').select2({ placeholder: t['KHU_VUC'], allowClear: true, width: '140px' });
      $('#statusSearch').select2({ placeholder: t['TRANG_THAI'], allowClear: true, width: '140px' });
      $('#typeTemp').select2({ placeholder: t['LOAI_TEM'], allowClear: true, width: '140px' });
      $('#supplier').select2({ placeholder: t['CHON_NHA_CUNG_CAP'], allowClear: true, width: '170px' });
    });
  }


  statisticList() {
    this.requestBoxSendService.requestBoxSendStatistic().subscribe((res) => {
      this.statistic = res.data;
    });
  }

  fetch() {
    const timePicker = $('.timePicker');
    let supplier = '';
    if ($('#supplier').val() === null || isNaN($('#supplier').val())) {
      supplier = '';
    } else {
      supplier = $('#supplier').val();
    }

    console.log(timePicker.val().split('-')[1]);
    this.query = {
      agencyId: supplier,
      proviceId: $('#area').val(),
      requestStatus: $('#statusSearch').val(),
      fromDate: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim().split('/').join('-')
        : '',
      toDate: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim().split('/').join('-')
        : '',
      prefix: $('.prefix').val(),
      idStart: $('.serialStart').val(),
      idEnd: $('.serialEnd').val(),
      type: $('#typeTemp').val(),
      code: $('.code').val(),
      page: this.pageIndex,
      pageSize: this.page_size,
    };

    this.requestBoxSendService.requestBoxSendList(this.query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_data = res.data.totalElement;
          if (
            res.data.items == null ||
            (res.data.item && res.data.item.length == 0)
          ) {
            this.total_data = 0;
            this.loading_left = false;
            this.data = [];
            this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU'), this.translate.instant('THONG_BAO'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
            return;
          }
          this.data = res.data.items.map((item: any) => {
            let tmpItem = item;
            tmpItem.serialStart = this.formatSerial(item.idStart, item.prefix);
            tmpItem.serialEnd = this.formatSerial(item.idEnd, item.prefix);
            return tmpItem;
          });

          if (this.data !== null && this.data.length > 0) {
            this.data.map((item, i) => {
              if (i === 0) {
                this.viewDetail(item, i);
              }
            });
          }
          this.loading_left = false;
          return;
        }
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      },
      (err) => {
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(err.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  getArea() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.area = citiesList;
    });
  }

  search() {
    this.pageIndex = 1;
    this.loading_left = true;
    this.fetch();
  }

  reset() {
    $('.prefix').val('').trigger('change');
    $('.code').val('').trigger('change');
    $('.serialStart').val('').trigger('change');
    $('.serialEnd').val('').trigger('change');
    $('#area').val(null).trigger('change');
    $('#supplier').val(null).trigger('change');
    $('#statusSearch').val(null).trigger('change');
    $('.timePicker').val(null).trigger('change');
    $('#typeTemp').val(null).trigger('change');
    this.pageIndex = 1;
    this.fetch();
  }


  viewDetail(item, i) {
    this.bundleType = item.bundleType;
    this.item_active = i;
    const query = {
      type: this.bundleType,
    };
    // @ts-ignore
    this.requestBoxSendService
      .requestBoxSendDetail(query, item.id)
      .subscribe((res) => {
        this.item_detail = res.data;
        this.item_detail.serialStart = this.formatSerial(
          res.data.idStart,
          res.data.prefix
        );
        this.item_detail.serialEnd = this.formatSerial(
          res.data.idEnd,
          res.data.prefix
        );
      });
    this.requestBoxSendService
      .stampSerial(item.prefix + '-' + item.idStart)
      .subscribe((res) => {
        if (res.data) {
          const stampSerialDetail = { ...res.data };
          const arr = [];
          res.data.service.map((val) => {
            console.log('val', val)
            if (val === 'CG') {
              arr.push(' Chống hàng giả');
            }
            if (val === 'BH') {
              arr.push(' Bảo hành');
            }
            if (val === 'TH') {
              arr.push(' Tràn hàng');
            }
            if (val === 'DD') {
              arr.push(' Định danh');
            }
          });
          stampSerialDetail.service = arr;
          this.stampSerialDetail = stampSerialDetail;
        }
      });
  }

  ViewDetailTracking() {
    clickTracking('qcheck_reback_manage', 'stamp_reback', 'qcheck_reback_detail', this.item_detail.id);
    visibleContent('qcheck_reback_detail', 'reback_info', '');
  }

  // load page danh sach lịch sử đóng thùng
  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      this.loading_left = true;

      this.fetch();
    }
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )

    if (this.pageIndex * this.page_size < this.total_data) {
      this.pageIndex = this.pageIndex + 1;
      this.loading_left = true;

      this.fetch();
    }
  }

  inputPageList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      this.loading_left = true;

      this.fetch();
    }
  }

  handleReturnStampBox() {
    const body = {
      type: this.bundleType,
    };
    this.requestBoxSendService
      .requestBoxSendActive(this.item_detail.id, body)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            clickTracking('form_confirm', 'reback_perform', 'qcheck_reback_detail', '');
            this.toastr.success(this.translate.instant('HUY_YEU_CAU_THANH_CONG'), this.translate.instant('THANH_CONG'));
            this.returnStampBox.hide();
            this.fetch();
            return;
          }
          this.toastr.error(`${res.message}`, this.translate.instant('THAT_BAI'));
        },
        (error) => {
          this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
        }
      );
  }

  trackingReturnStampBox() {
    clickTracking('qcheck_reback_detail', 'request_cancel', 'form_confirm', '');
    visibleContent('qcheck_reback_detail', 'form_confirm', '')
  }

  // search serial
  searchInfoSerial(code: string) {
    this.router.navigate(['/find-stamp'], { queryParams: { code } });
  }

  formatSerial(id: any, prefix: string) {
    let serial_f: string = '';
    id = id.toString();
    if (id && prefix) {
      let pad = '000000';
      let serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/requestBoxSend/requestBoxSend.component.ts